module.exports = __webpack_public_path__ + "img/zw.aa8aa901.png";